import { computed, toValue } from 'vue';

import type { ComputedRef, MaybeRefOrGetter } from 'vue';

export function reactiveOption<T>(
  source: MaybeRefOrGetter<T | undefined>,
  defaultValue: T
): ComputedRef<T>;
export function reactiveOption<T>(
  source: MaybeRefOrGetter<T | undefined>
): ComputedRef<T | undefined>;
export function reactiveOption<T>(source: MaybeRefOrGetter<T | undefined>, defaultValue?: T) {
  return computed(() => {
    const resolved = toValue(source);
    return resolved ?? defaultValue;
  });
}
